import { NextUIProvider } from "@nextui-org/react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

export function Providers({ children }: { children: React.ReactNode }) {
	return (
		<NextUIProvider locale="cs-CZ">
			<NextThemesProvider attribute="class" defaultTheme="light">
				{children}
			</NextThemesProvider>
		</NextUIProvider>
	);
}
